var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRoundCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 35.999C28.8364 35.999 36 28.8364 36 19.999C36 11.1626 28.8364 4 20 4C11.1636 4 4 11.1626 4 19.999C4 28.8364 11.1636 35.999 20 35.999ZM29.7246 14.7878C29.1444 14.2076 28.2037 14.2076 27.6234 14.7878L17.7467 24.6645L12.7266 19.6444C12.1464 19.0641 11.2057 19.0641 10.6254 19.6444C10.0452 20.2246 10.0452 21.1653 10.6254 21.7456L16.2669 27.387C17.0842 28.2043 18.4093 28.2043 19.2266 27.387L29.7246 16.889C30.3049 16.3088 30.3049 15.368 29.7246 14.7878Z",
    fill: "#364356"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRoundCheck);
export default __webpack_public_path__ + "static/media/iconRoundCheck.a5d4fa92.svg";
export { ForwardRef as ReactComponent };